import { FC, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, TextField, Dialog, DialogContent, DialogActions } from '@mui/material';
import { SCUIButton } from '../../../atomic/atoms';
import Swal from 'sweetalert2';
import { SmsTemplateCommand } from '../../../services/command';
import { useTranslation } from 'react-i18next';
import { SMS } from '../smsTemplate.classes';
interface IProps {
    open?: any;
    onCloseMenu?: any;
    selectedRow?: any;
}

export const SCUISmsTriggerDrawerContent: FC<IProps> = ({ open, onCloseMenu, selectedRow }) => {
    const { t } = useTranslation();
    const [customerId, setCustomerId] = useState();
    const [phoneNumber, setPhoneNumber] = useState();
    const [cacheState, setCacheState] = useState<any>();

    const handleChangeCustomerId = (event: any) => {
        setCustomerId(event.target.value);
    };
    const handleChangePhoneNumber = (event: any) => {
        setPhoneNumber(event.target.value);
    };
    const handleValueChange = (index: number, e: any) => {
        setCacheState({ ...cacheState, [e.target.id]: e.target.value });
    };

    const triggerSms = () => {
        Swal.fire({
            text: 'Sms göndermek istediğinizden emin misiniz',
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.send'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                let params: any = {};
                let paramss: any = {};

                selectedRow.arrayKeyword.forEach((item: any) => {
                    paramss[item] = cacheState[item];
                });
                params.messageTemplateData = paramss;
                params.phoneNumber = phoneNumber;
                params.customerId = customerId;
                params.cultureCode = selectedRow.cultureCode;
                params.messageTemplateType = selectedRow.smsTemplateKeyword;
                params.messagePriorty = 0;
                params.applicationType = 0;

                SmsTemplateCommand.TriggerSms(params);

                Swal.fire('Sms Gönderildi', ' ', 'success');
            }
        });
    };

    return (
        <Dialog
            open={open}
            onClose={onCloseMenu}
            className={SMS.triggerDialog}
            data-keyword={selectedRow?.smsTemplateKeyword}
        >
            <DialogContent className={SMS.triggerDialogContent}>
                <Grid className={`designCollectiveselectedRowGrid ${SMS.triggerDialogInner}`}>
                    <Grid container sx={{ paddingTop: '2rem' }} className={SMS.triggerHeader}>
                        <Grid
                            className={SMS.triggerTitleBox}
                            sx={{ paddingLeft: '3rem' }}
                            size={{
                                md: 6,
                                xs: 6,
                                lg: 11,
                            }}
                        >
                            <h1 className={`headtxt ${SMS.triggerTitle}`}>{'Sms Tetikleme'}</h1>
                        </Grid>

                        <Grid
                            className={SMS.triggerCloseBox}
                            size={{
                                md: 1,
                                xs: 1,
                                lg: 1,
                            }}
                        >
                            <CloseIcon className={`svg_icons ${SMS.btnTriggerClose}`} onClick={onCloseMenu} />
                        </Grid>
                    </Grid>
                    <Grid container sx={{ padding: '3rem' }} className={SMS.triggerForm}>
                        <br />
                        <Grid
                            className={SMS.triggerFieldPhone}
                            size={{
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <TextField
                                className={SMS.inputTriggerPhone}
                                label="Phone Number"
                                margin="dense"
                                id="parameterValue"
                                fullWidth
                                onChange={handleChangePhoneNumber}
                            />
                        </Grid>
                        <Grid
                            className={SMS.triggerFieldCustomerId}
                            size={{
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <TextField
                                className={SMS.inputTriggerCustomerId}
                                label="Customer ID"
                                margin="dense"
                                id="parameterValue"
                                fullWidth
                                onChange={handleChangeCustomerId}
                            />
                        </Grid>
                        {selectedRow.arrayKeyword && (
                            <Grid
                                className={SMS.triggerKeywordList}
                                size={{
                                    md: 12,
                                    xs: 12,
                                }}
                            >
                                {selectedRow.arrayKeyword &&
                                    selectedRow.arrayKeyword.map((item: any, index: any) => (
                                        <TextField
                                            className={`${SMS.triggerKeywordField} ${SMS.inputTriggerKeyword}`}
                                            data-keyword-name={item}
                                            data-keyword-index={index}
                                            margin="dense"
                                            required
                                            id={item}
                                            label={item}
                                            fullWidth
                                            onChange={(e) => handleValueChange(index, e)}
                                            key={index}
                                        />
                                    ))}
                            </Grid>
                        )}
                        <DialogActions className={SMS.triggerActions}>
                            <Grid
                                container
                                justifyContent="flex-end"
                                sx={{ marginTop: '2rem' }}
                                className={SMS.triggerActionsRow}
                                size={{
                                    xs: 12,
                                    sm: 12,
                                }}
                            >
                                {selectedRow.body && (
                                    <SCUIButton
                                        className={SMS.btnTriggerSend}
                                        text={'Sms Gönder'}
                                        type="primary"
                                        sizeType="fixed"
                                        size={'l'}
                                        onClick={() => triggerSms()}
                                    >
                                        {' '}
                                    </SCUIButton>
                                )}
                            </Grid>
                        </DialogActions>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};
